import { COUNTRY_SHORT_NAME } from '@commons/constants';

export const ADDRESS_USE_CASE_TYPE = {
  SIMPLE_ADDRESS: 'STREET_SEARCH_FULL_ADDRESS',
  FULL_ADDRESS: 'DEFAULT',
  PANAMA_HONDURAS_FORMAT: 'PANAMA_HONDURAS_FORMAT',
  WITHOUT_CORNER_FORMAT: 'WITHOUT_CORNER_FORMAT',
  EXTENDED_FORMAT: 'EXTENDED_FORMAT',
  VENEZUELAN_FORMAT: 'VENEZUELAN_FORMAT',
  PERU_FORMAT: 'PERU_FORMAT',
  SALVADOR_NICARAGUA_FORMAT: 'SALVADOR_NICARAGUA_FORMAT',
  ECUADOR_FORMAT: 'ECUADOR_FORMAT',
};
const {
  PANAMA_HONDURAS_FORMAT,
  WITHOUT_CORNER_FORMAT,
  EXTENDED_FORMAT,
  VENEZUELAN_FORMAT,
  PERU_FORMAT,
  FULL_ADDRESS,
  SALVADOR_NICARAGUA_FORMAT,
  ECUADOR_FORMAT,
} = ADDRESS_USE_CASE_TYPE;

export function getDefaultAddressUseCase({ country, addressUseCase }) {
  if (
    country === COUNTRY_SHORT_NAME.PANAMA ||
    country === COUNTRY_SHORT_NAME.HONDURAS
  )
    return PANAMA_HONDURAS_FORMAT;
  if (
    country === COUNTRY_SHORT_NAME.DOMINICANAN_REPUBLIC ||
    country === COUNTRY_SHORT_NAME.COSTA_RICA ||
    country === COUNTRY_SHORT_NAME.GUATEMALA
  )
    return WITHOUT_CORNER_FORMAT;
  if (country === COUNTRY_SHORT_NAME.PARAGUAY) return EXTENDED_FORMAT;
  if (country === COUNTRY_SHORT_NAME.ECUADOR) return ECUADOR_FORMAT;
  if (country === COUNTRY_SHORT_NAME.VENEZUELA) return VENEZUELAN_FORMAT;
  if (
    country === COUNTRY_SHORT_NAME.EL_SALVADOR ||
    country === COUNTRY_SHORT_NAME.NICARAGUA
  )
    return SALVADOR_NICARAGUA_FORMAT;
  if (country === COUNTRY_SHORT_NAME.PERU) return PERU_FORMAT;
  return addressUseCase || FULL_ADDRESS;
}

function City({
  id,
  addressUseCase,
  name,
  longitude,
  latitude,
  country,
  defaultArea,
}) {
  return {
    id,
    addressUseCase: getDefaultAddressUseCase({ country, addressUseCase }),
    name,
    longitude,
    latitude,
    defaultArea,
  };
}

export default City;
